import React from 'react'

import MaskedInput from 'antd-mask-input'

import { InputProps } from './Input'

import './DataEntryStyles.less'

interface InputMaskProps extends InputProps {
  mask: string
}

const InputMask: React.FC<InputMaskProps> = (props) => {
  return <MaskedInput className={`${props.className}`} {...props} id={props.id || props.name} />
}

export default InputMask
